/**
 * @module admin ui
 */
import { createReducer } from '@reduxjs/toolkit';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { companyActions } from '~/behaviors/actions/company.actions';
import { accountActions } from '~/behaviors/actions/account.actions';

const defaultState = {
  isLoadingCompanies: false, // TODO: might want to move this to a more generic domain (e.g., "companies" or "global" or "entities")
  isLoadingCompaniesMetadata: false,
  isSwitchingCompany: false,
  switchingCompanyId: null,
};

const reset = () => defaultState;

const merge = (updates) => (state) => ({
  ...state,
  ...updates,
});

// The switchCompany thunk takes the target companyId as its argument, so grab
// it from action.meta.arg to flag which row is switching. Guard meta because
// other reducers' tests dispatch a bare switchCompany.pending action (no meta)
// to exercise their own reset handlers.
const startSwitchingCompany = (state, action) => ({
  ...state,
  isSwitchingCompany: true,
  switchingCompanyId: action.meta?.arg ?? null,
});

const stopSwitchingCompany = merge({ isSwitchingCompany: false, switchingCompanyId: null });

const adminUI = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(companyActions.fetchCompanyList.pending, merge({ isLoadingCompanies: true }));
  builder.addCase(companyActions.fetchCompanyList.fulfilled, merge({ isLoadingCompanies: false }));
  builder.addCase(companyActions.fetchCompanyList.rejected, merge({ isLoadingCompanies: false }));
  builder.addCase(companyActions.fetchCompaniesMetadata.pending, merge({ isLoadingCompaniesMetadata: true }));
  builder.addCase(companyActions.fetchCompaniesMetadata.fulfilled, merge({ isLoadingCompaniesMetadata: false }));
  builder.addCase(companyActions.fetchCompaniesMetadata.rejected, merge({ isLoadingCompaniesMetadata: false }));
  builder.addCase(accountActions.switchCompany.pending, startSwitchingCompany);
  builder.addCase(accountActions.switchCompany.fulfilled, stopSwitchingCompany);
  builder.addCase(accountActions.switchCompany.rejected, stopSwitchingCompany);
});

export default adminUI;
